import React, { Component, CSSProperties } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Footer.scss";
import footerLogo from "../../assets/footer-logo-emailajent.png";

interface FooterProps {}

interface FooterState {}

class Footer extends Component<FooterProps, FooterState> {
  constructor(props: FooterProps) {
    super(props);
    this.state = {};
  }

  render(): React.JSX.Element {
    return (
      <footer className="footer">
        <div className="footer__links-row">
          <div className="footer__inner">
            <nav className="footer__social" aria-label="Social">
              <a
                className="footer__social-link"
                href="https://example.com/linkedin"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
              <a
                className="footer__social-link"
                href="https://example.com/instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
              <a
                className="footer__social-link"
                href="https://example.com/x"
                target="_blank"
                rel="noopener noreferrer"
              >
                X.com
              </a>
            </nav>
            <div className="footer__right" aria-label="Contact and legal">
              <a href="mailto:contact@hq.emailajent.com">contact@hq.emailajent.com</a>
              <span className="footer__sep" aria-hidden="true">
                ·
              </span>
              <Link to="/raise-ticket">Raise Ticket</Link>
              <span className="footer__sep" aria-hidden="true">
                ·
              </span>
              <span className="footer__legal">
                <NavLink to="/terms">Terms &amp; Conditions</NavLink>
                <NavLink to="/privacy">Privacy Policy</NavLink>
              </span>
            </div>
          </div>
        </div>

        <div className="footer__watermark">
        <img className="footer__watermark_logo" src={footerLogo} alt="Email Ajent footer watermark" />
          <div className="footer__inner">
            <div className="footer__meta">
              <p className="footer__copyright">
              Copyright © 2026 EmailAjent. All rights reserved.
              </p>
              <p className="footer__made-with">Made with 🤍&nbsp;&nbsp;•&nbsp;&nbsp;Shipped with hope!</p>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
